(function () {

	angular.module('qbePortal').controller('QBYearsHeld', QBYearsHeld);

	QBYearsHeld.$inject = ['$scope', 'MODULE_INFO'];

	function QBYearsHeld($scope, MODULE_INFO) {
		var vm = this;

		vm.$onInit = function () {
			vm.fieldValue = vm.ngModel;
		}

		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({
				name: name,
				setHierarchyFn: setHierarchyFn
			});
		}

		vm.onValueChanged = function () {
			vm.update({
				name: vm.name,
				value: vm.fieldValue
			});
		}

		// Calculate age using DoB.
		function calcAge() {

			return (moment(new Date()).diff(moment(vm.dob, 'DD/MM/YYYY'), 'years', true));

		}

		// Refine select options depending on age
		vm.getFilteredOptions = function () {

			var fullOptions = vm.options.slice();
			var age = calcAge();

			if (age > 17 && age <= 18) {
				fullOptions = fullOptions.splice(0, 2);
			} else if (age > 18 && age <= 19) {
				fullOptions = fullOptions.splice(0, 3);
			} else if (age > 19 && age <= 20) {
				fullOptions = fullOptions.splice(0, 4);
			} else if (age > 20 && age <= 21) {
				fullOptions = fullOptions.splice(0, 5);
			} else if (age > 21 && age <= 22) {
				fullOptions = fullOptions.splice(0, 6);
			}

			return fullOptions;

		}


	}

	angular.module('qbePortal').component('qbYearsHeld', {
		templateUrl: '../ngviews/components/qbYearsHeld.html',
		controller: QBYearsHeld,
		controllerAs: 'vm',
		bindings: {
			options: '<',
			name: '@',
			ngModel: '<',
			update: '&',
			setHierarchy: '&',
			dob: '<'
		}
	});
})();
